import logo from "@/assets/logo.png";
import { SITE_NAME } from "@/lib/routeMeta";
import { cn } from "@/lib/utils";

/**
 * Single source of truth for the visible brand mark (logo + wordmark).
 * The name is derived from SITE_NAME so it can never drift from head metadata.
 */

interface BrandMarkProps {
  /** Hide the wordmark (collapsed sidebar, tight headers). */
  iconOnly?: boolean;
  /** Tailwind size classes for the logo image. */
  iconClassName?: string;
  /** Tailwind classes for the wordmark text. */
  textClassName?: string;
  className?: string;
}

export function BrandMark({
  iconOnly = false,
  iconClassName = "h-8 w-8",
  textClassName = "font-display text-lg font-bold tracking-tight text-foreground",
  className,
}: BrandMarkProps) {
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <img
        src={logo}
        alt=""
        aria-hidden="true"
        width={1024}
        height={1024}
        className={cn("object-contain", iconClassName)}
      />
      {!iconOnly && <span className={textClassName}>{SITE_NAME}</span>}
    </span>
  );
}
